import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: '千喜鹤2025届校园招聘'
    }
  },
  {
    path: '/jobList',
    name: 'jobList',
    component: () => import('../views/JobListView.vue'),
    meta: {
      title: '职位列表'
    }
  },
  {
    path: '/jobDetail',
    name: 'jobDetail',
    component: () => import('../views/JobDetailView.vue'),
    meta: {
      title: '职位详情'
    }
  },
  {
    path: '/fillInfo',
    name: 'fillInfo',
    component: () => import('../views/FillInfoView.vue'),
    meta: {
      title: '填写资料'
    }
  },
  {
    path: '/success',
    name: 'success',
    component: () => import('../views/SuccessView.vue'),
    meta: {
      title: '完成投递'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
router.afterEach(() => {
  window.scrollTo(0, 0)
})
export default router
